const ERROR_NAME = "BagApiBadRequestError";

type BagErrorResponse = {
  errorCode: string;
  errorMessage: string;
  userMessage: string;
  level: string;
  parameterName: string | null;
  messageContext: string[];
}[];

export class BagApiBadRequestError extends Error {
  public readonly bagErrorMessage: string;

  constructor(message: string, potentialApiErrorResponse: unknown) {
    super(message);
    this.name = ERROR_NAME;

    this.bagErrorMessage = this.formatUserMessage(potentialApiErrorResponse);
  }

  private formatUserMessage(potentialApiErrorResponse: unknown): string {
    let dataToProcess;

    try {
      dataToProcess =
        typeof potentialApiErrorResponse === "string"
          ? JSON.parse(potentialApiErrorResponse)
          : potentialApiErrorResponse;
    } catch (error) {
      dataToProcess = null;
    }

    if (
      !dataToProcess ||
      !Array.isArray(dataToProcess) ||
      !dataToProcess.length
    ) {
      return this.message;
    }

    const apiErrorObject = (dataToProcess as BagErrorResponse)[0];

    if (!apiErrorObject || !apiErrorObject.userMessage) {
      return this.message;
    }

    let formattedUserMessage = apiErrorObject.userMessage;

    if (
      apiErrorObject.messageContext &&
      Array.isArray(apiErrorObject.messageContext)
    ) {
      apiErrorObject.messageContext.forEach((contextValue, index) => {
        const placeholder = `{${index}}`;

        formattedUserMessage = formattedUserMessage.replace(
          placeholder,
          contextValue,
        );
      });
    }

    return formattedUserMessage;
  }
}

export const isBagApiBadRequestError = (
  potentialErrorObject: unknown,
): boolean => {
  return !!(
    potentialErrorObject &&
    potentialErrorObject instanceof Error &&
    potentialErrorObject.name === ERROR_NAME
  );
};
